declare namespace $ {

	export class $rise_toggle_demo extends $mol_example_small {
		Toggle( ): $rise_toggle
		sub( ): readonly(any)[]
		tags( ): readonly(any)[]
		aspects( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map